import { useTranslation } from "react-i18next";
import {
  ChallengeCardWrapper,
  ChallengeHeader,
  ChallengeAmount,
  ChallengeInfoButton,
  ChallengeProgressBar,
} from "./ChallengeUtils";
import { ChallengeInfoProps } from "@/pages/challenges/ChallengeInfo";
import { Fragment, useRef } from "react";
import { useStoryDetail } from "@/pages/home/api";
import { appConfig } from "@/lib/site-config";
import StoriesComponent from "@/components/stories/StoriesModal";

interface Props extends ChallengeInfoProps {}

export const ChallengeActiveCard = ({ gainedAmount, targetAmount }: Props) => {
  const { t } = useTranslation();
  const { data: storyData, isLoading: isStoryLoading } = useStoryDetail(
    appConfig.storySlug.aboutChallenge
  );
  const storiesModal = useRef(null);

  const showStories = () => {
    if (storiesModal.current) {
      // @ts-expect-error i know this
      storiesModal.current.openStories(0);
    }
  };

  return (
    <Fragment>
      <ChallengeCardWrapper>
        <div className="flex items-start justify-between">
          <div className="flex flex-col gap-1">
            <div className="flex items-center gap-2">
              <ChallengeHeader
                text={t("the_necessary_don_for_a_super_achievement")}
              />
            </div>
            {targetAmount && <ChallengeAmount amount={targetAmount} />}
          </div>
          <ChallengeInfoButton onClick={showStories} />
        </div>
        {gainedAmount && targetAmount && (
          <ChallengeProgressBar
            gainedAmount={gainedAmount}
            targetAmount={targetAmount}
          />
        )}
      </ChallengeCardWrapper>
      {storyData && !isStoryLoading && (
        <StoriesComponent ref={storiesModal} storiesData={[storyData]} />
      )}
    </Fragment>
  );
};
